const SET_USER_CONTRACTS = "SET_USER_CONTRACTS";
const SET_USER_PERMISSIONS = "SET_USER_PERMISSIONS";
const SET_UN_CONSTRUCTED_USER_PERMISSIONS =
  "SET_UN_CONSTRUCTED_USER_PERMISSIONS";
const SET_USER = "SET_USER";
const SET_KEYCLOAK = "SET_KEYCLOAK";
const LOGOUT = "LOGOUT";

export {
  SET_USER,
  SET_KEYCLOAK,
  LOGOUT,
  SET_USER_CONTRACTS,
  SET_USER_PERMISSIONS,
  SET_UN_CONSTRUCTED_USER_PERMISSIONS
};
